import React from "react";

export default function FinalCTA() {
  return (
    <section 
      className="py-20 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 relative overflow-hidden"
      aria-label="Final Call to Action"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-2xl"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-white rounded-full blur-xl"></div>
        <div className="absolute top-1/4 right-1/4 w-20 h-20 bg-white rounded-full blur-lg"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Content */}
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 abc-bold leading-tight">
            Ready to Create Your Perfect Biodata?
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto abc-regular leading-relaxed">
            Join thousands of satisfied users who have created beautiful biodatas with our platform. 
            Start your journey today - it's completely free!
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button
            onClick={() => {
              document
                .getElementById("create-biodata")
                .scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center px-8 py-4 text-lg font-semibold text-purple-600 bg-white hover:bg-gray-50 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-white/50 abc-semibold"
            aria-label="Create Your Biodata Now"
          >
            <span className="mr-2">✨</span>
            Create Your Biodata Now
            <span className="ml-2">→</span>
          </button>
          
          <button
            onClick={() => {
              document
                .getElementById("templates")
                .scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center px-8 py-4 text-lg font-semibold text-white bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-white/30 abc-semibold border border-white/30"
            aria-label="View Templates"
          >
            <span className="mr-2">🎨</span>
            View Templates
          </button>
        </div>

        {/* Features Highlight */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-2xl mb-2">⚡</div>
            <h3 className="font-semibold text-white mb-2 abc-semibold">Lightning Fast</h3>
            <p className="text-white/80 text-sm abc-regular">Create in minutes</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-2xl mb-2">🆓</div>
            <h3 className="font-semibold text-white mb-2 abc-semibold">Completely Free</h3>
            <p className="text-white/80 text-sm abc-regular">No hidden costs</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-2xl mb-2">🔒</div>
            <h3 className="font-semibold text-white mb-2 abc-semibold">100% Secure</h3>
            <p className="text-white/80 text-sm abc-regular">Your data is safe</p>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <p className="text-white/70 text-sm abc-regular mb-4">
            Trusted by thousands of users worldwide
          </p>
          <div className="flex justify-center items-center space-x-8 opacity-60">
            <div className="text-white/50 text-xs abc-regular">⭐ 4.9/5 Rating</div>
            <div className="text-white/50 text-xs abc-regular">👥 10K+ Users</div>
            <div className="text-white/50 text-xs abc-regular">🎨 50+ Templates</div>
          </div>
        </div>
      </div>
    </section>
  );
}
